<template>
  <v-container class="login-form tw-bg-white tw-pt-24 tw-px-10">
    <PasswordResetForm />
  </v-container>
</template>
<script>
import PasswordResetForm from "@/components/auth/PasswordResetForm.vue";

export default {
  name: "PasswordReset",
  components: {
    PasswordResetForm,
  },
};
</script>
